export const isNullOrUndefined = (value) => {
    return value === null || value === undefined
}

export const getUnitName = (unit, quantity) => {
    if (!unit) return ""

    const [singular, plural] = unit.split(",")
    return quantity > 1 ? plural || singular : singular
}
